import { Component, Optional, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../../../shared/base-components/base.component';
import { VehicleMobileHomeService } from '../../../../../services/vehicle-mobile-home.service';

export class LinkMobileHomeSectionModalData {
    constructor(
        public vehicleId: number
    ) { }
}

@Component({
    selector: 'link-mobile-home-section-modal',
    templateUrl: './link-mobile-home-section-modal.html'
})

export class LinkMobileHomeSectionModalComponent extends BaseComponent {
    public vehicleId: number;

    constructor(public dialogRef: MatDialogRef<LinkMobileHomeSectionModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: LinkMobileHomeSectionModalData,
        private mobileHomeService: VehicleMobileHomeService
    ) {
        super();

        this.vehicleId = data.vehicleId;
    }

    ngOnInit() {
    }

    vehicleSelected(foundVehicle: any) {
        this.mobileHomeService.saveMobileHomeRelatedVehicle(this.vehicleId, foundVehicle.vehicleId).subscribe(
            result => {
                this.dialogRef.close(true);
            },
            error => this.handleValidationResult(error)
        );
    }

    /**
     * Closes the dialogRef
     * */
    cancel() {
        this.dialogRef.close(false);
    }
}
